import { FuelTag } from '@frete.com/fuel-react';
import React from 'react';
import * as Styled from './styled';

export const Tags: React.FC<{
  scrolledValue: number;
  isSmallProfile: boolean;
  isApprovalValid: boolean;
}> = ({ scrolledValue, isSmallProfile, isApprovalValid }) => {
  const shouldRenderWrapper = isApprovalValid;

  const renderIsApprovedOnGRTag = isApprovalValid && (
    <FuelTag
      highlight
      color="blue"
      label="Já Aprovado em GR"
      shape="rectangle"
      icon="risk-management"
      iconStyle="filled"
      uppercase
      data-testid="gr-approved-tag"
    />
  );

  return shouldRenderWrapper ? (
    <Styled.TagWrapper scrolledValue={scrolledValue} isSmallProfile={isSmallProfile} data-testid="tags-wrapper">
      {renderIsApprovedOnGRTag}
    </Styled.TagWrapper>
  ) : null;
};
